import { IconType } from "core/types";
import { newThemeColors } from "ds_legacy/materials/colors";
import { sizing } from "ds_legacy/materials/metrics";
import { Caption, FONT_SIZE_16 } from "ds_legacy/materials/typography";
import { InfoIcon } from "lucide-react";
import React, { ReactNode } from "react";
import styled from "styled-components";

const ContentWrapper = styled.div<{ centered?: boolean; margin?: string }>`
  display: flex;
  align-items: ${(props) => (props.centered ? "center" : "flex-start")};
  ${(props) =>
    props.margin ? `margin: ${props.margin}` : `margin-bottom: ${sizing(1)};`}
`;

export type InfoCaptionProps = {
  captionStyle?: React.CSSProperties;
  centered?: boolean;
  children?: ReactNode;
  color?: string;
  icon?: IconType;
  margin?: string;
  text?: string;
  wrapperStyle?: React.CSSProperties;
};

const InfoCaption = ({
  captionStyle,
  centered,
  children,
  color,
  icon,
  margin,
  text,
  wrapperStyle,
}: InfoCaptionProps) => {
  const Icon = icon || InfoIcon;
  return (
    <ContentWrapper centered={centered} margin={margin} style={wrapperStyle}>
      <div>
        <Icon
          size={FONT_SIZE_16}
          style={{
            color: color ? color : newThemeColors.primary.main,
            fontSize: FONT_SIZE_16,
          }}
        />
      </div>
      <Caption
        as="p"
        data-testid="info-caption"
        style={{ whiteSpace: "pre-line", ...captionStyle }}
      >
        {children != null ? children : text}
      </Caption>
    </ContentWrapper>
  );
};
export default InfoCaption;
